import React, { useState, useEffect } from 'react';
import { TextField, Button, Card, CardContent , Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import CandidateService from '../services/candidateService';

const Options = () => {
  const [options, setOptions] = useState([]);

  const [fieldName, setFieldName] = useState('');
  const [value, setValue] = useState('');
  const [label, setLabel] = useState('');
  const [groupName, setGroupName] = useState('A');

  const fetchOptions = async () => {
    try {
      const response = await CandidateService.getAllOptions();
      const data = response.data;
      setOptions(data || []);
    } catch (error) {
      console.error('Error fetching options:', error);
    }
  };

  const createOption = async () => {
    try {
      const requestBody = {
        groupName,
        fieldName,
        value,
        label
      };
      requestBody.value = label.replace(/\s+/g, '-').toLowerCase();

      const response = await CandidateService.createOption(requestBody);
      const createdOption = response.data;

      setOptions(prevOptions => [...prevOptions, createdOption]);
      clearForm();
    } catch (error) {
      console.error('Error creating option:', error);
    }
  };

  const clearForm = () => {
    setFieldName('');
    setValue('');
    setLabel('');
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  return (
    <div>
      <Card>
        <CardContent>
          <h2>Create Option</h2>
          <form>
            <TextField size='small' label="Option Name" value={fieldName || ''} onChange={(e) => setFieldName(e.target.value)} />
            <TextField size='small' label="Label" value={label || ''} onChange={(e) => setLabel(e.target.value)} />
            <Button variant="contained" onClick={createOption}>Create Option</Button>
          </form>
        </CardContent>
      </Card>
      <h2>Current Options</h2>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Option Name</TableCell>
              <TableCell>Label</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.map((option, index) => (
              <TableRow key={index}>
                <TableCell>{option.fieldName || ''}</TableCell>
                <TableCell>{option.label || ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Options;
